module.exports = __webpack_public_path__ + "static/media/callRefuse.ecbc0be0.svg";